<template>
    <div class="coupon-guide-page">
        <section class="coupon-hero">
            <div class="hero-inner">
                <div class="hero-content">
                    <p class="hero-badge">임직원 여러분</p>
                    <h1 class="hero-title">
                        우리 회사 인근 매장에서
                        <span>특별 혜택을</span>
                        받아가세요!
                    </h1>
                </div>
                <img class="hero-icon" :src="heroIcon" alt="쿠폰 혜택 아이콘" />
            </div>
        </section>

        <main class="coupon-main">
            <section class="intro-grid">
                <article class="coupon-card benefit-card">
                    <h2>
                        우리 회사 근처
                        <span>혜택 통으로 담았어요!</span>
                    </h2>
                    <ol class="benefit-list">
                        <li>별도 APP 설치 없이 카톡으로 혜택 발송</li>
                        <li>매달 업데이트 되는 맞춤 혜택</li>
                        <li>번거로운 정산 업무 없음</li>
                        <li>회사 부담금 없이 복지 체감도 상승</li>
                    </ol>
                </article>

                <article class="coupon-card value-card">
                    <h2>
                        추가 비용 부담 0%
                        <span>관리 0분</span>
                    </h2>
                    <p>우리 회사만을 위한 로컬 복지 도입</p>
                    <p class="value-subcopy">
                        지역 소상공인과 함께 상생하는 우리회사형 로컬 복지입니다.
                    </p>
                </article>
            </section>

            <section class="coupon-card process-card">
                <h2>서비스 이용 프로세스</h2>
                <ul class="process-list">
                    <li v-for="(step, idx) in processSteps" :key="step.title">
                        <em class="step-badge">{{ step.step }}</em>
                        <img :src="step.icon" :alt="step.title" />
                        <strong>{{ step.title }}</strong>
                        <span class="process-desc">{{ step.description }}</span>
                        <span v-if="idx < processSteps.length - 1" class="step-arrow" aria-hidden="true">→</span>
                    </li>
                </ul>
            </section>

            <section class="coupon-card notice-card">
                <h2>이용 전 확인하세요!</h2>
                <ol>
                    <li>
                        <strong>아이폰 사용자라면?</strong>
                        <p>
                            설정 방법 : 설정 &gt; [사용자 이름] &gt; iCloud &gt; 비공개 릴레이 ‘끔’
                            <br />
                            더 쉬운 방법 : 설정 변경이 번거로우시다면, 네이버나 카카오톡 앱의 QR 스캔 기능을 이용해 보세요.
                        </p>
                    </li>
                    <li>
                        <strong>쿠폰은 매장 직원에게 보여주세요!</strong>
                        <p>
                            쿠폰은 매장 직원 확인 후 사용 처리되며, 사용 완료된 쿠폰은 재사용할 수 없습니다.
                            동일 쿠폰은 지정된 유효기간 내에만 사용 가능합니다.
                        </p>
                    </li>
                </ol>
            </section>
        </main>
    </div>
</template>

<script>
import heroIcon from "@/assets/images/coupon/상단 아이콘.png";
import step1Icon from "@/assets/images/coupon/1. QR스캔.png";
import step2Icon from "@/assets/images/coupon/2. 맞춤 혜택 조회.png";
import step3Icon from "@/assets/images/coupon/3. 혜택 사용.png";
import step4Icon from "@/assets/images/coupon/4. 단골 매장 등록.png";

export default {
    name: "HFOCP001",
    data() {
        return {
            heroIcon,
            processSteps: [
                {
                    step: "STEP 1",
                    title: "QR스캔",
                    description: "기업 전용 QR코드 스캔",
                    icon: step1Icon,
                },
                {
                    step: "STEP 2",
                    title: "맞춤 혜택 조회",
                    description: "추천 혜택 매장/브랜드 쿠폰 확인",
                    icon: step2Icon,
                },
                {
                    step: "STEP 3",
                    title: "혜택 사용",
                    description: "현장에서 직원에게 제시 후 즉시 적용",
                    icon: step3Icon,
                },
                {
                    step: "STEP 4",
                    title: "단골 등록",
                    description: "매장 QR 스캔 시 단골 혜택 쿠폰 지급",
                    icon: step4Icon,
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.coupon-guide-page {
    min-height: calc(100dvh - 65px);
    padding: 8px 14px 28px;
    background: #ffffff;
    color: #2d3138;
    box-sizing: border-box;
}

.coupon-hero {
    width: min(100%, 1120px);
    margin: 0 auto;

    .hero-inner {
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: flex-end;
        padding: 14px clamp(118px, 19vw, 224px) 14px 16px;
        border-radius: 10px;
        background: linear-gradient(155deg, #f1892c 0%, #ea761f 100%);
        color: #ffffff;
    }

    .hero-content {
        min-width: 0;
        position: relative;
        z-index: 1;
    }

    .hero-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        padding: 0 13px;
        margin: 0 0 8px;
        border-radius: 999px;
        background: #fff3dd;
        color: #d06822;
        font-size: 17px;
        font-weight: 800;
        letter-spacing: -0.01em;
    }

    .hero-title {
        margin: 0;
        font-size: clamp(25px, 4.6vw, 50px);
        line-height: 1.08;
        letter-spacing: -0.03em;
        font-weight: 800;
        word-break: keep-all;

        span {
            display: block;
            width: fit-content;
            background: linear-gradient(transparent 64%, #ffd08a 64%);
        }
    }

    .hero-icon {
        position: absolute;
        right: 0;
        bottom: 0;
        width: clamp(110px, 18vw, 206px);
        height: auto;
        flex-shrink: 0;
    }
}

.coupon-main {
    width: min(100%, 1120px);
    margin: 12px auto 0;
}

.intro-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 10px;
}

.coupon-card {
    border-radius: 10px;
    border: 1px solid #d9dde5;
    background: #f8f9fb;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.benefit-card,
.value-card {
    padding: 14px 16px;
}

.benefit-card h2,
.value-card h2,
.process-card h2,
.notice-card h2 {
    margin: 0;
    text-align: center;
    font-weight: 800;
    letter-spacing: -0.02em;
    word-break: keep-all;
}

.benefit-card h2,
.value-card h2 {
    font-size: clamp(18px, 2.2vw, 34px);
    line-height: 1.2;
    margin-bottom: 10px;
}

.benefit-card h2 span,
.value-card h2 {
    color: #ef7b26;
}

.benefit-card h2 span,
.value-card h2 span {
    display: block;
}

.benefit-list {
    counter-reset: item;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 6px;
        font-size: clamp(11px, 1.35vw, 20px);
        line-height: 1.4;
        color: #3f444d;
        word-break: keep-all;
    }

    li:last-child {
        margin-bottom: 0;
    }

    li::before {
        content: counter(item);
        counter-increment: item;
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        border-radius: 50%;
        background: #f07f28;
        color: #ffffff;
        font-size: 10px;
        font-weight: 700;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
}

.value-card {
    text-align: center;

    p {
        margin: 0;
        font-size: clamp(14px, 1.8vw, 28px);
        font-weight: 700;
        line-height: 1.35;
        word-break: keep-all;
    }

    .value-subcopy {
        margin-top: 8px;
        color: #6b7280;
        font-size: clamp(10px, 1.2vw, 16px);
        font-weight: 500;
    }
}

.process-card {
    padding: 14px;
    margin-bottom: 10px;
    background: #fff6ec;
    border: 1px solid #f4cfa8;

    h2 {
        color: #eb7827;
        font-size: clamp(18px, 2.2vw, 34px);
        margin-bottom: 10px;
    }
}

.process-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 8px;

    li {
        position: relative;
        padding: 10px 8px 12px;
        border-radius: 8px;
        border: 1px solid #ebd6c0;
        background: #ffffff;
        text-align: center;
    }

    .step-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 16px;
        padding: 0 8px;
        border-radius: 999px;
        background: #fff2e4;
        color: #de6d20;
        border: 1px solid #f7cfa8;
        font-size: 9px;
        font-style: normal;
        font-weight: 700;
        letter-spacing: 0.01em;
    }

    img {
        display: block;
        width: 52px;
        height: 52px;
        object-fit: contain;
        margin: 8px auto;
    }

    strong {
        display: block;
        color: #ea7622;
        font-size: clamp(11px, 1.4vw, 23px);
        line-height: 1.25;
        margin-bottom: 4px;
        word-break: keep-all;
    }

    .process-desc {
        display: block;
        color: #4b5563;
        font-size: clamp(10px, 1.12vw, 17px);
        line-height: 1.35;
        word-break: keep-all;
    }

    .step-arrow {
        position: absolute;
        right: -9px;
        top: 50%;
        transform: translateY(-50%);
        color: #db6d21;
        font-size: 18px;
        font-weight: 800;
        z-index: 1;
    }
}

.notice-card {
    padding: 16px;

    h2 {
        color: #ee7c24;
        font-size: clamp(18px, 2.2vw, 34px);
        margin-bottom: 10px;
    }

    ol {
        margin: 0;
        padding-left: 18px;
    }

    li {
        margin-bottom: 10px;
        font-size: clamp(14px, 1.9vw, 28px);
        line-height: 1.4;
        word-break: keep-all;
    }

    li:last-child {
        margin-bottom: 0;
    }

    strong {
        display: block;
        margin-bottom: 3px;
        color: #2f343d;
    }

    p {
        margin: 0;
        color: #59606c;
        font-size: clamp(13px, 1.65vw, 24px);
    }
}

@media (min-width: 1024px) {
    .coupon-guide-page {
        border-top: 1px solid #eee;
    }
}

@media (max-width: 1023px) {
    .coupon-guide-page {
        min-height: calc(100dvh - 60px);
        padding: 8px 10px 22px;
    }

    .coupon-hero .hero-inner {
        align-items: center;
        padding: 12px clamp(96px, 32vw, 148px) 13px 12px;
    }

    .coupon-hero .hero-badge {
        height: 26px;
        font-size: 13px;
        padding: 0 11px;
        margin-bottom: 6px;
    }

    .coupon-hero .hero-title {
        font-size: clamp(24px, 7.2vw, 33px);
    }

    .coupon-hero .hero-icon {
        width: clamp(92px, 29vw, 136px);
    }

    .intro-grid {
        gap: 8px;
    }

    .benefit-card,
    .value-card,
    .process-card,
    .notice-card {
        padding: 12px;
    }

    .process-list {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 8px;

        .step-arrow {
            display: none;
        }

        li {
            min-height: 146px;
        }

        img {
            width: 48px;
            height: 48px;
        }
    }
}

@media (max-width: 680px) {
    .intro-grid {
        grid-template-columns: 1fr;
    }

    .coupon-hero .hero-inner {
        padding: 11px clamp(84px, 29vw, 122px) 12px 11px;
    }

    .coupon-hero .hero-title {
        font-size: clamp(20px, 7vw, 30px);
    }

    .coupon-hero .hero-icon {
        width: clamp(82px, 26vw, 108px);
    }
}
</style>